import { useTranslation } from "react-i18next";
import { App } from "antd";

import ConfirmationModal from "@/components_v2/Modal/ConfirmationModal";
import { useRevokeSanctionMutation } from "@/redux/service";
import { LiftBanModalProps } from "@/domains/moderation/types";

const LiftBanModal = ({ sanction, userName, onClose }: LiftBanModalProps) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const [revoke, { isLoading }] = useRevokeSanctionMutation();

  const handleConfirm = async () => {
    if (!sanction) {
      return;
    }
    try {
      await revoke(sanction.id).unwrap();
      notification.success({ message: t("moderation.liftBan.done") });
      onClose();
    } catch {
      notification.error({ message: t("moderation.liftBan.error") });
    }
  };

  return (
    <ConfirmationModal
      open={sanction !== null}
      onCancel={onClose}
      onConfirm={handleConfirm}
      isLoading={isLoading}
      title={t("moderation.liftBan.title", { name: userName })}
      confirmButtonText={t("moderation.liftBan.confirm")}
      content={null}
    />
  );
};

export default LiftBanModal;
